<template>
  <div class="scrollbar customBanner-temp sfft">
    <loader
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="pageLoader"
    ></loader>
    <message
      :message="response_msg"
      :messageType="msg_type"
      v-if="response_msg != ''"
    ></message>
    <!-- <div class="col-12 inMiddle-area pb-0">
      <div class="pt-2 radius">
        <div class="map-nav d-flex align-items-center justify-content-between">
          <ul class="d-flex align-items-center whiteBG-tab">
            <li class="userList" :class="show_tab == '1' ? 'active' : ''">
              <a data-toggle="tab" href="" @click.prevent="show_tab = '1'">
                Banners
              </a>
            </li>
            <li class="userList" :class="show_tab == '2' ? 'active' : ''">
              <a data-toggle="tab" href="" @click.prevent="show_tab = '2'">
                Referral Links
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <div
      class="col-12"
      v-if="!pageLoader && tradingView !== '' && show_tab == '1'"
    >
      <!-- <div class="row justify-content-center">
        <div class="col-lg-6 col-md-12">
          <div
            class="card custom-card border-0 noneBoxShadow d-flex align-items-center justify-content-between"
          >
            <div class="card-body d-flex align-items-center">
              <div class="mr-3">
                <h6 class="main-content-label">Select Language</h6>
              </div>
              <div class="form-group field-wrapper mb-1">
                <select
                  class="float-field form-control"
                  onclick="this.setAttribute('value', this.value);"
                  value=""
                >
                  <option value=""></option>
                  <option value="english">English</option>
                  <option value="hindi">Hindi</option>
                </select>
                <label class="float-label">Language</label>
              </div>
            </div>
            <div class="card-right-img pr-4">
              <img
                src="../../../../static/fxView/images/linguistics.svg"
                alt="Icon"
                width="70"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div
            class="card custom-card border-0 noneBoxShadow d-flex align-items-center justify-content-between"
          >
            <div class="card-body d-flex align-items-center">
              <div class="mr-3">
                <h6 class="main-content-label">Select Banner Type</h6>
              </div>
              <div class="form-group field-wrapper mb-1">
                <select
                  class="float-field form-control"
                  onclick="this.setAttribute('value', this.value);"
                  value=""
                >
                  <option value=""></option>
                  <option value="english">Static Banner</option>
                  <option value="hindi">Dynamic Banner</option>
                </select>
                <label class="float-label">Type</label>
              </div>
            </div>
            <div class="card-right-img pr-4">
              <img
                src="../../../../static/fxView/images/advertisement.svg"
                alt="Icon"
                width="70"
              />
            </div>
          </div>
        </div>
      </div> -->
      <div class="row space">
        <div class="col-12">
          <div class="whiteBG box-shadow p-2">
            <ul class="selectBannerSize d-flex align-items-center">
              <li
                v-for="banner in bannerSizes"
                :class="currentBannerSize == banner ? 'active' : ''"
                @click="() => (currentBannerSize = banner)"
              >
                {{ banner }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row space">
        <div
          v-for="image in bannerImages[currentBannerSize]"
          :class="{
            'col-12 col-md-2': currentBannerSize == '120x600',
            'col-12 col-md-3': currentBannerSize == '150x300' || currentBannerSize == '250x250',
            'col-12 col-md-4': currentBannerSize == '300x250', 
            'col-12 col-xl-6': currentBannerSize == '728x90',
          }"
        >
          <div class="card custom-card refBanner border-0">
            <div class="px-5 pt-3 text-center">
              <img
                :src="
                  '../../../../static/fxView/images/banners/' +
                  currentBannerSize +
                  '-' +
                  image
                "
                alt="Icon"
              />
            </div>
            <div class="card-body text-center">
              <!-- <label class="font-weight-bold mb-3">Tight Spreads</label> -->
              <div class="card-form">
                <div
                  class="form-group field-wrapper mb-1 w-100 position-relative"
                >
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    :value="embedContent(currentBannerSize, image)"
                  />
                  <a
                    href="javsacript:void(0);"
                    @click="() => copyText(image)"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                  <span v-if="currentImage == image" class="copiedText"
                    >Copied!</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-12 col-md-4">
          <div class="card custom-card refBanner border-0">
            <img
              src="../../../../static/fxView/images/placeholderbaneer.svg"
              alt="Icon"
            />
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Ultra low Commissions</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="card custom-card refBanner border-0">
            <img
              src="../../../../static/fxView/images/placeholderbaneer.svg"
              alt="Icon"
            />
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Range of platforms</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    
    <div
      class="col-12"
      v-if="!pageLoader && tradingView !== '' && show_tab == '2'"
    >
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="card custom-card getLink border-0">
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Range of platforms</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="card custom-card getLink border-0">
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Range of platforms</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="card custom-card getLink border-0">
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Range of platforms</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="card custom-card getLink border-0">
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Range of platforms</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="card custom-card getLink border-0">
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Range of platforms</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="card custom-card getLink border-0">
            <div class="card-body text-center">
              <label class="font-weight-bold mb-3">Range of platforms</label>
              <div class="card-form">
                <div class="form-group field-wrapper mb-1 w-100">
                  <input
                    type="text"
                    :placeholder="`${$env_var.ibLink}promotional-tools`"
                    class="float-field form-control pt-0"
                    name=""
                  />
                  <a
                    href="#"
                    class="grd_btn copy d-flex align-items-center justify-content-center"
                    ><feather size="15px" type="copy"></feather
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "PROMOTIONAL-TOOLS",
  mixins: [fxViewMixins],
  data() {
    return {
      pageTitle: this.$options.name,
      show_tab: "1",
      currentImage: "",
      currentBannerSize: "120x600",
      bannerSizes: ["120x600", "150x300", "250x250", "300x250", "728x90"],
      bannerImages: {
        "120x600": ["1", "2", "3", "4", "5"],
        "150x300": ["14", "15", "16", "17"],
        "250x250": ["10", "11", "12", "13"],
        "300x250": ["6", "7", "8", "9", "10", "11", "12", "13"],
        "728x90": ["18", "19", "20", "21", "22", "23"],
      },
      referral_link: "",
      pageLoader: false,
      response_msg: "",
      msg_type: "",
    };
  },
  created() {
    this.setData(this.pageTitle);
    if(localStorage.getItem('ib-origin') && localStorage.getItem('ib-origin') == 'eu'){
      this.referral_link =
        "<a href=" +
        this.$env_var.eucpLink +
        "register?refLink=" +
        window.btoa(this.get_user.id) +
        "&refRm=" +
        window.btoa(this.get_user.rm_id) +
        "><img src='https://fxview.com/static/img/about.64900cf.png' /></a>";
    }else{
      this.referral_link =
        "<a href=" +
        this.$env_var.cpLink +
        "register?refLink=" +
        window.btoa(this.get_user.id) +
        "&refRm=" +
        window.btoa(this.get_user.rm_id) +
        "><img src='https://fxview.com/static/img/about.64900cf.png' /></a>";
    }
  },
  methods: {
    embedContent(size, name) {
      if(localStorage.getItem('ib-origin') && localStorage.getItem('ib-origin') == 'eu'){
         return `<a href="${this.$env_var.eucpLink}register?refLink=${window.btoa(
          this.get_user.id
        )}&refRm=${window.btoa(
          this.get_user.rm_id
        )}"><img src='${this.$env_var.ibLink}/static/fxView/images/banners/${size}-${name}' /></a>`;
      }else{
        return `<a href="${this.$env_var.cpLink}register?refLink=${window.btoa(
          this.get_user.id
        )}&refRm=${window.btoa(
          this.get_user.rm_id
        )}"><img src='${this.$env_var.ibLink}/static/fxView/images/banners/${size}-${name}' /></a>`;
      }
    },
    copyText(image) {
      this.currentImage = image;
      navigator.clipboard.writeText(
        this.embedContent(this.currentBannerSize, image)
      );
      setTimeout(() => {
        this.currentImage = "";
      }, 2000);
    },//<img src='https://dev.finvasia.com:8093/static/fxView/images/banners/
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/promotion/promotional_tools.vue